/**
 * Data layer for `campaign-visibility-assigned-only-all-per-role`. Thin typed fetch wrappers over /api/v1/campaign-visibility-assigned-only-all-per-role.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface CampaignVisibilityAssignedOnlyAllPerRoleRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListCampaignVisibilityAssignedOnlyAllPerRoleResponse {
	count: number;
	items: CampaignVisibilityAssignedOnlyAllPerRoleRow[];
}

export interface CreateCampaignVisibilityAssignedOnlyAllPerRoleBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/campaign-visibility-assigned-only-all-per-role";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListCampaignVisibilityAssignedOnlyAllPerRoleResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListCampaignVisibilityAssignedOnlyAllPerRoleResponse>(res);
}

export async function create(body: CreateCampaignVisibilityAssignedOnlyAllPerRoleBody): Promise<CampaignVisibilityAssignedOnlyAllPerRoleRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<CampaignVisibilityAssignedOnlyAllPerRoleRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const campaignVisibilityAssignedOnlyAllPerRoleQueryKeys = {
	all: ["campaign-visibility-assigned-only-all-per-role"] as const,
	list: () => [...campaignVisibilityAssignedOnlyAllPerRoleQueryKeys.all] as const,
	detail: (id: string) => [...campaignVisibilityAssignedOnlyAllPerRoleQueryKeys.all, id] as const,
};
